import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Pricing } from './pages/Pricing';
import { Book } from './pages/Book';
import { Programs } from './pages/Programs';
import { Summer2026 } from './pages/Summer2026';
import { Fall2026 } from './pages/Fall2026';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
export function App() {
  return <Router data-id="element-0" data-mp="2mm2j470bqezq">
      <Layout data-id="element-1" data-mp="2mmlut5zds75b">
        <Routes data-id="element-2" data-mp="2mn5bykh7iria">
          <Route path="/" element={<Home data-id="element-4" data-mp="2mjznn7gejtnm" />} data-id="element-3" data-mp="2mnnhk7prei2v" />
          <Route path="/programs" element={<Programs data-id="element-6" data-mp="31bibfrfi6shj" />} data-id="element-5" data-mp="31agput0v2nlk" />
          <Route path="/fall-2026" element={<Fall2026 data-id="element-8" data-mp="2wka20ve6b74d" />} data-id="element-7" data-mp="31c1ksjr388jy" />
          <Route path="/summer-2026" element={<Summer2026 data-id="element-10" data-mp="2wip7h5ruzo6i" />} data-id="element-9" data-mp="2wjqkvgwckmre" />
          <Route path="/about" element={<About data-id="element-12" data-mp="28tmdcyg1g2v4" />} data-id="element-11" data-mp="28ufo0ai4bcij" />
          <Route path="/pricing" element={<Pricing data-id="element-14" data-mp="28s2xva27hvue" />} data-id="element-13" data-mp="28t4j27cxrypu" />
          <Route path="/contact" element={<Contact data-id="element-16" data-mp="23u9q4cl98ts0" />} data-id="element-15" data-mp="23vkuadim43jn" />
          <Route path="/book" element={<Book data-id="element-18" data-mp="3ijxqiu0iq6lh" />} data-id="element-17" data-mp="23v2sz2h3ez4v" />
        </Routes>
      </Layout>
    </Router>;
}